import OcontentProvider from "./OcontentProvider";

export default class OcontentEventVideoReplayProvider extends OcontentProvider {
  protected _baseUrl = this.baseUrl + "event-replays/";

  async getEventVideoReplay(eventVideoReplayName: string): Promise<string> {
    try {
      const res = await fetch(`${this._baseUrl}${eventVideoReplayName}.txt`);
      if (res.ok) {
        return await res.text();
      }

      return "";
    } catch (err) {
      return "";
    }
  }
}
